const contextualHelp = {
  EncuestasPendientesList: `<span class="text-uppercase text-weight-bold">INFORMACIÓN</span><br><br>
    Actualmente se encuentra en la pantalla de listado de encuestas pendientes<br><br>
    El objetivo de esta pantalla es revisar todas las encuestas que están completadas por los pacientes, y 
    además, poder ver el listado de todas las encuestas revisadas en el día de hoy. <br><br>
    <span class="text-uppercase text-weight-bold">¿Cómo funciona?</span><br><br>
    Encontrará un listado con el numero de encuestas completadas, el resultado y el paciente que la ha completado. <br><br>
    A la derecha, encontrará dos posibles acciones:
    <ul>
        <li><b>Marcar encuesta como revisada:</b> Marcará la encuesta como revisada, previa confirmación, y se informará al paciente de que su encuesta ha sido revisada correctamente</li>
        <li class="q-pt-sm"><b>Ver Encuesta:</b> Se podrá entrar al detalle de la encuesta</li>
    </ul>
    `,
  HistoricoEncuestasPacienteList: ``,
  MisEncuestasList: ``,
  PacientesCrud: ``,
  PacientesList: ``,
  MyProfilePage: ``
};

export { contextualHelp };
